<script>
import DailyAllowanceForm from '@views/reports/dailyAllowances/daily-allowance-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    DailyAllowanceForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    value: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    // eslint-disable-next-line
    reportId: {
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(dailyAllowance) {
      this.setUnchanged();
      this.$emit('updated', dailyAllowance);
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.dailyAllowanceModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal
    ref="dailyAllowanceModal"
    v-model="showModal"
    size="lg"
    hide-footer
    :title="$t('titles.edit_daily_allowance')"
    static
    @hide="hide"
    @hidden="$emit('hidden')"
  >
    <DailyAllowanceForm v-if="showModal" :loaded-id="loadedId" :report-id="reportId" @submitted="submit" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
